import { render } from "./Meteogram.vue?vue&type=template&id=37f89145"
import script from "./Meteogram.vue?vue&type=script&lang=js"
export * from "./Meteogram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__